import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API } from "../../../constants/apiPath";
import axios from "axios";
import { startLoading, stopLoading } from "../loader/loaderSlice";


const getAuthHeaders = () => {
  const token = localStorage.getItem("accessToken");

  return token
    ? { Authorization: `Bearer ${token}` }
    : {};
};


const initialState = {
  isLoading: false,
  cart: [],
  checkoutcart: [],
};

const THUNK_METHODS = {
  CART_GET: "user/cart",
  CART_CHECKOUT_GET: "user/checkout/cart",
  CART_UPDATE: "user/update/cart",
  CART_DELETE: "user/delete/cart",
};

export const getUserCart = createAsyncThunk(
  THUNK_METHODS.CART_GET,
  async (args, { dispatch, rejectWithValue }) => {
    try {
      dispatch(startLoading());

      const { data } = await axios({
        method: "GET",
        url: `${process.env.REACT_APP_API_URL}${API.CART.GET}`,
        withCredentials: true,
        headers: getAuthHeaders(),
      });

      return data.cart;
    } catch (error) {
      console.error(error.message);
      return rejectWithValue("SignUp failed");
    } finally {
      dispatch(stopLoading());
    }
  }
);


export const getCheckoutCart = createAsyncThunk(
  THUNK_METHODS.CART_CHECKOUT_GET,
  async (args, { dispatch, rejectWithValue }) => {
    try {
      dispatch(startLoading());

      const { data } = await axios({
        method: "GET",
        url: `${process.env.REACT_APP_API_URL}${API.CART.CHECKOUT}`,
        withCredentials: true,
        headers: getAuthHeaders(),
      });

      return data.cart;
    } catch (error) {
      console.error(
        "GET CHECKOUT CART ERROR:",
        error.response?.data || error.message
      );

      return rejectWithValue(
        error.response?.data?.error || error.message
      );
    } finally {
      dispatch(stopLoading());
    }
  }
);



export const updateUserCart = createAsyncThunk(
  THUNK_METHODS.CART_UPDATE,
  async (productjson, { dispatch, rejectWithValue, getState }) => {
    try {
      dispatch(startLoading());
        await axios({
          method: "POST",
          url: `${process.env.REACT_APP_API_URL}${API.CART.UPDATE}`,
          withCredentials: true,
          headers: getAuthHeaders(),
          data: productjson,
        });

      return;
    } catch (error) {
      console.error(
        "UPDATE USER CART ERROR:",
        error.response?.data || error.message
      );

      return rejectWithValue(
        error.response?.data?.error || error.message
      );
    } finally {
      dispatch(stopLoading());
    }
  }
);


export const deleteUserCart = createAsyncThunk(
  THUNK_METHODS.CART_DELETE,
  async (cartItem, { dispatch, rejectWithValue }) => {
    try {
      dispatch(startLoading());

      await axios({
        method: "DELETE",
        url: `${process.env.REACT_APP_API_URL}${API.CART.DELETE}`,
        withCredentials: true,
        headers: getAuthHeaders(),
        data: cartItem,
      });

      return;
    } catch (error) {
      console.error(
        "DELETE USER CART ERROR:",
        error.response?.data || error.message
      );

      return rejectWithValue(
        error.response?.data?.error || error.message
      );
    } finally {
      dispatch(stopLoading());
    }
  }
);


export const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getUserCart.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getUserCart.fulfilled, (state, action) => {
      state.cart = action.payload;
      state.isLoading = false;
    });
    builder.addCase(getUserCart.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(getCheckoutCart.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getCheckoutCart.fulfilled, (state, action) => {
      state.checkoutcart = action.payload;
      state.isLoading = false;
    });
    builder.addCase(getCheckoutCart.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(updateUserCart.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(updateUserCart.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(updateUserCart.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(deleteUserCart.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(deleteUserCart.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(deleteUserCart.rejected, (state) => {
      state.isLoading = false;
    });
  },
});
export const { } = cartSlice.actions;
